import React, { useState, useEffect } from "react";
import "./Cards.css";

const Cards = ({ leads }) => {
  const [cards, setCards] = useState({
    total_leads: "0",
    total_new_leads: "0",
    total_booked_leads: "0",
    total_decline_leads: "0",
    today_leads: "0",
    today_new_leads: "0",
    today_booked_leads: "0",
    today_decline_leads: "0",
  });
  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let _card = [];

    if (leads) {
      // for total
      _card["total_leads"] = leads.length || "0";

      _card["total_new_leads"] =
        leads.filter((item) => item.lead_status_position === "1").length || "0";

      _card["total_booked_leads"] =
        leads.filter(
          (item) =>
            item.lead_data.trigger_value === 1 ||
            item.lead_data.trigger_value === 2
        ).length || "0";

      _card["total_decline_leads"] =
        leads.filter((item) => item.lead_data.trigger_value === 3).length ||
        "0";

      // for today
      _card["today_leads"] =
        leads.filter((item) => {
          const enquiryDate = new Date(item.lead_data.enquiry_date);
          enquiryDate.setHours(0, 0, 0, 0);
          return enquiryDate.getTime() === today.getTime();
        }).length || "0";

      _card["today_new_leads"] =
        leads.filter((item) => {
          const enquiryDate = new Date(item.lead_data.enquiry_date);
          enquiryDate.setHours(0, 0, 0, 0);
          return (
            item.lead_status_position === "1" &&
            enquiryDate.getTime() === today.getTime()
          );
        }).length || "0";

      _card["today_booked_leads"] =
        leads.filter((item) => {
          const enquiryDate = new Date(item.lead_data.enquiry_date);
          enquiryDate.setHours(0, 0, 0, 0);
          return (
            (item.lead_data.trigger_value === 1 ||
              item.lead_data.trigger_value === 2) &&
            enquiryDate.getTime() === today.getTime()
          );
        }).length || "0";

      _card["today_decline_leads"] =
        leads.filter((item) => {
          const enquiryDate = new Date(item.lead_data.enquiry_date);
          enquiryDate.setHours(0, 0, 0, 0);
          return (
            item.lead_data.trigger_value === 3 &&
            enquiryDate.getTime() === today.getTime()
          );
        }).length || "0";

      // set to card state
      setCards(_card);
    }
  }, [leads]);

  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget w-100">
            <div className="dash-widgetimg">
              <svg width={20} fill="#00cfe8" viewBox="0 0 384 512">
                <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.total_leads}</span>
              </h5>
              <h6>Total Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget w-100">
            <div className="dash-widgetimg">
              <svg width={25} fill="#d563f8" viewBox="0 0 576 512">
                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.total_new_leads}</span>
              </h5>
              <h6>Total New Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget dash1 w-100">
            <div className="dash-widgetimg">
              <svg width={25} fill="#28c76f" viewBox="0 0 576 512">
                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.total_booked_leads}</span>
              </h5>
              <h6>Total Booked Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget dash2 w-100">
            <div className="dash-widgetimg">
              <svg width={25} fill="#ec7878" viewBox="0 0 576 512">
                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.total_decline_leads}</span>
              </h5>
              <h6>Total Declined Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget w-100">
            <div className="dash-widgetimg">
              <svg width={20} fill="#00cfe8" viewBox="0 0 384 512">
                <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.today_leads}</span>
              </h5>
              <h6>Today Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget w-100">
            <div className="dash-widgetimg">
              <svg width={25} fill="#d563f8" viewBox="0 0 576 512">
                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.today_new_leads}</span>
              </h5>
              <h6>Today New Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget dash1 w-100">
            <div className="dash-widgetimg">
              <svg width={25} fill="#28c76f" viewBox="0 0 576 512">
                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.today_booked_leads}</span>
              </h5>
              <h6>Today Booked Leads</h6>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex">
          <div className="dash-widget dash2 w-100">
            <div className="dash-widgetimg">
              <svg width={25} fill="#ec7878" viewBox="0 0 576 512">
                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z" />
              </svg>
            </div>
            <div className="dash-widgetcontent">
              <h5>
                <span className="counters">{cards.today_decline_leads}</span>
              </h5>
              <h6>Today Declined Leads</h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cards;
